var _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDatetimePickerIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;}.b{stroke:#0d0d0d;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 18,
    height: 18
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.429 2)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 12,
    height: 13,
    rx: 2,
    transform: "translate(0 1)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    y2: 3,
    transform: "translate(9)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    y2: 3,
    transform: "translate(3)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 12,
    transform: "translate(0 6)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatetimePickerIcon);
export default __webpack_public_path__ + "static/media/datetime-picker-icon.31531eebdc6bf46945008a0456ce7bb0.svg";
export { ForwardRef as ReactComponent };